import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import SubscriptionPaymentPanel from "@/components/SubscriptionPaymentPanel";
import { Lock } from "lucide-react";

export default function AdminSubscriptionBlocked() {
  const { user, logout, refreshUser } = useAuth();
  const sub = user?.subscription;

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-4 py-10">
      <div className="max-w-xl w-full text-center space-y-6">
        <Lock className="mx-auto text-[#E63946]" size={48} />
        <div>
          <h1 className="font-display text-3xl text-white">Suscripción pendiente</h1>
          <p className="text-white/60 text-sm mt-3">
            El periodo de tu suscripción ha vencido. Realiza el pago para recuperar el acceso al panel de
            administración.
          </p>
        </div>
        <SubscriptionPaymentPanel subscription={sub} onUpdated={refreshUser} />
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <button type="button" onClick={logout} className="btn-outline text-sm">
            Cerrar sesión
          </button>
          <Link to="/" className="btn-outline text-sm inline-flex items-center justify-center">
            Ir al sitio público
          </Link>
        </div>
      </div>
    </div>
  );
}
